// rv-rating-summary: loaded only where the block is used (blocks/rv-rating-summary.liquid)

(() => {
  const fill = () => {
    const source = document.querySelector('[data-rv-reviews]');
    document.querySelectorAll('[data-rv-rating-summary]').forEach((summary) => {
      const count = Number(source?.dataset.count || 0);
      if (!count) {
        summary.hidden = true;
        summary.dataset.empty = '';
        return;
      }
      const average = Number(source.dataset.average);
      const hasAverage = source.dataset.average !== '' && !Number.isNaN(average) && average > 0;
      const label = hasAverage
        ? average.toLocaleString(document.documentElement.lang || 'en-US', { minimumFractionDigits: 1, maximumFractionDigits: 1 })
        : '';
      const stars = summary.querySelector('.rv-stars');
      stars.hidden = !hasAverage;
      if (hasAverage) {
        stars.style.setProperty('--rv-rating', String(average));
        stars.setAttribute('aria-label', (summary.dataset.ratingLabel || '[rating] out of 5 stars').replace('[rating]', label));
      }
      const countLabel = source.dataset.countLabel || String(count);
      const template = countLabel === '1' ? summary.dataset.textOne : summary.dataset.textMany;
      summary.querySelector('[data-rv-rating-text]').textContent = template
        .replace('[rating]', label)
        .replace('[count]', countLabel);
      delete summary.dataset.empty;
      summary.hidden = false;
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fill);
  else fill();
  // Horizon re-renders the product section when the variant changes.
  new MutationObserver(() => {
    if (document.querySelector('[data-rv-rating-summary][hidden]:not([data-empty])')) fill();
  }).observe(document.body, { childList: true, subtree: true });
})();
